import type { JSX } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';

export function RequireMemberships(): JSX.Element {
  const location = useLocation();
  const { bootstrap, isLoading } = useAuth();
  const memberships = bootstrap?.memberships ?? null;

  if (location.pathname === '/onboarding') {
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ minHeight: '60vh' }}>
        <CircularProgress />
        <Typography color="text.secondary">Loading memberships...</Typography>
      </Stack>
    );
  }

  if (!bootstrap) {
    return <Outlet />;
  }

  if (memberships && memberships.length === 0) {
    return (
      <Navigate to={bootstrap.mode === 'identity' && bootstrap.platformPermissions.length > 0 ? '/platform' : '/onboarding'} replace />
    );
  }

  return <Outlet />;
}
